import { render, staticRenderFns } from "./HistoryReports.vue?vue&type=template&id=babf4658&scoped=true"
import script from "./HistoryReports.vue?vue&type=script&lang=js"
export * from "./HistoryReports.vue?vue&type=script&lang=js"
import style0 from "./HistoryReports.vue?vue&type=style&index=0&id=babf4658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babf4658",
  null
  
)

export default component.exports